<h1 mat-dialog-title>Set product eligibility</h1>
<div mat-dialog-content class="eligibility-dialog">
  <p class="member-name">{{ memberName }}</p>
  @if (data.user) {
    <p>{{ data.user.email }}</p>
    <p>Set an enrollment window for this user and the selected products.</p>
    @for (window of windows; track window.productId) {
      <p>{{ getProductLabel(windowProduct(window.productId)) }}: {{ window.startDate }} – {{ window.endDate }}</p>
    }
  }
  @if (loading) {
    <p>Loading products...</p>
  }
  @if (!loading && context) {
    <form [formGroup]="form">
      <mat-form-field appearance="outline">
        <mat-label>Products</mat-label>
        <mat-select formControlName="productIds" multiple>
          @for (product of context?.products; track product) {
            <mat-option [value]="getProductId(product)">
              {{ getProductLabel(product) }}
            </mat-option>
          }
        </mat-select>
        @if (form.get('productIds')?.hasError('required')) {
          <mat-error>Select at least one product.</mat-error>
        }
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>{{ data.user ? 'Enrollment Start Date' : 'Eligibility Start Date' }}</mat-label>
        <input matInput type="date" formControlName="startDate">
        @if (form.get('startDate')?.hasError('required')) {
          <mat-error>Start Date is required.</mat-error>
        }
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>{{ data.user ? 'Enrollment End Date' : 'Eligibility End Date' }}</mat-label>
        <input matInput type="date" formControlName="endDate">
        @if (form.get('endDate')?.hasError('required')) {
          <mat-error>End Date is required.</mat-error>
        }
      </mat-form-field>
      @if (form.hasError('invalidDateRange')) {
        <p role="alert">End Date must be on or after Start Date.</p>
      }
    </form>
  }
  @if (error) {
    <app-inlinemessage level="error" [message]="error"></app-inlinemessage>
  }
</div>
<div mat-dialog-actions align="end">
  <button mat-button type="button" (click)="cancel()">Cancel</button>
  <button mat-raised-button color="primary" type="button" [disabled]="loading || saving || form.invalid || !context" (click)="save()">
    {{ saving ? 'Saving...' : 'Save' }}
  </button>
</div>
